<template>
  <div class="color-palette-item" :style="{background: model}" :class="{active: active}">
    <div class="info hidden-tablet" :class="{invert: !getContrastYIQ(model), active: showInput === 1}" v-if="!readonly">
      <a class="open">
        <i class="material-icons">call_made</i>
      </a>
    </div>

    <div class="info hidden-tablet" :class="{invert: !getContrastYIQ(model), active: showInput === 1}" v-if="!readonly">
      <div class="color" @click="toggleInput($refs.hex, 1)">{{ model }}</div>

      <div class="input">
        <div class="unit">#</div>
        <div class="field">
          <input type="text"
                 :value="model.slice(1)"
                 @blur="toggleInput($el, false)"
                 @keyup.enter="blurInput($el)"
                 @keyup.esc="blurInput($el)"
                 @input="handleHex"
                 ref="hex"
          />
        </div>
      </div>

      <a @click="handleCopy(model)" class="copy">
        <i class="material-icons">content_copy</i>
      </a>
    </div>

    <div class="info hidden-tablet" :class="{invert: !getContrastYIQ(model), active: showInput === 2}" v-if="!readonly">
      <div class="color" @click="toggleInput($refs.rgb, 2)">rgb({{ rgb }})</div>

      <div class="input">
        <div class="unit">rgb(</div>
        <div class="field">
          <input type="text"
                 :value="rgb"
                 @blur="toggleInput($el, false)"
                 @keyup.enter="blurInput($el)"
                 @keyup.esc="blurInput($el)"
                 @change="handleRGB"
                 ref="rgb"
          />
        </div>
        <div class="unit">)</div>
      </div>

      <a @click="handleCopy(`rgb(${rgb})`)" class="copy">
        <i class="material-icons">content_copy</i>
      </a>
    </div>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard';
import { mapActions } from 'vuex';
import { getContrastYIQ, rgbToHex, hexToRgb } from '../../utils/helper';

export default {
  name: 'color-palette-item',
  data() {
    return {
      showInput: false,
      rgb: '',
    };
  },
  props: {
    model: String,
    active: Boolean,
    readonly: Boolean,
    onFocus: Function,
    onBlur: Function,
    onChange: Function,
    onUpdate: Function,
  },
  created() {
    const rgb = hexToRgb(this.model);
    this.rgb = rgb ? `${rgb.r}, ${rgb.g}, ${rgb.b}` : '';
  },
  watch: {
    model(to) {
      const rgb = hexToRgb(to);
      this.rgb = rgb ? `${rgb.r}, ${rgb.g}, ${rgb.b}` : '';
    },
  },
  methods: {
    ...mapActions('notification', [
      'addNotification',
    ]),
    toggleInput(el, value) {
      this.showInput = value;

      if (value) {
        this.$nextTick(() => el.focus());
        this.onFocus();
      } else {
        this.onBlur();
        this.onUpdate();
      }
    },
    handleHex(e) {
      this.onChange(`#${e.target.value}`);
    },
    handleRGB(e) {
      const rgb = e.target.value.split(',').map(Number);
      if (rgb && rgb.length === 3) {
        this.onChange(rgbToHex(rgb[0], rgb[1], rgb[2]));
      }
    },
    blurInput(el) {
      el.blur();
      this.showInput = false;
      this.onBlur();
    },
    handleCopy(value) {
      copy(value);
      this.addNotification({ message: 'Copied!' });
    },
    getContrastYIQ(hex) {
      return getContrastYIQ(hex);
    },
  },
};
</script>

<style lang="scss" scoped>
  .active {
    .info {
      opacity: 1;
    }
  }

  .color-palette-item {
    flex: 1;
    padding: 40px 20px;

    @include media($smallDesktop) {
      padding: 40px 15px;
    }

    @include media($mobile) {
      padding: 0;
    }
  }

  .info {
    font-weight: 500;
    opacity: 0;
    transition: $transition;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    &.invert {
      color: white;

      a {
        color: white;

        &:hover {
          color: white;
        }
      }

      .input {
        background: rgba($bg2, .1);
        border: 2px solid rgba(white, .1);
      }

      input {
        color: white;
      }
    }

    &.active {
      .color, .text {
        display: none;
      }

      .input {
        display: flex;
      }
    }
  }

  .open {
    opacity: 0;
    padding: 0 15px;
    margin-bottom: 10px;
    pointer-events: none;
  }

  .color {
    font-size: 30px;
    padding: 11px 15px;
    opacity: .5;
    flex: 1;
    border: 2px solid transparent;
  }

  .input {
    position: relative;
    margin-right: 10px;
    font-size: 30px;
    display: none;
    flex: 1;
    align-items: center;
    background: rgba(black, .1);
    border: 2px solid rgba(black, .1);
    border-radius: 4px;
    padding: 0 15px;
  }

  .copy {
    opacity: .5;
    cursor: pointer;
    transition: $transition;
    color: $dark;

    &:hover {
      opacity: 1;
      color: $dark;
    }
  }

  input {
    height: 60px;
    padding: 10px 0;
    background: none;
    border: none;
    color: $dark;
    font-size: 30px;
    width: 100%;
  }
</style>
